import { StoreType, useActions } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { refreshCalendar } from 'utils/refreshData';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const DEFAULT_LOGOUT_MESSAGE = "You've been logged out.";

interface LogoutOptions {
  onLogoutMessage?: string;
}

export const useLogout = () => {
  const history = useHistory();
  const { actions } = useActions();

  const { appConfig, lock, ticketTypeAccessToken } = useSelector((state: StoreType) => ({
    appConfig: state.app.config,
    ticketTypeAccessToken: state.calendar.ticketTypeAccessToken,
    lock: state.lock,
  }));

  const { currentLock, packageLock } = lock;
  // Consumer ticket groups never leak subsets from other users, so ensure the lock is not a handsell lock before unlocking/.

  const doLogout = async (options?: LogoutOptions) => {
    const onLogoutMessage = options?.onLogoutMessage ?? DEFAULT_LOGOUT_MESSAGE;

    if (currentLock?.ticketSubset[0] && !currentLock?.ticketSubset[0].purchaseVerifyInfo) {
      const ticketSubset: core.ITicketSubset = currentLock?.ticketSubset[0];
      // It is possible to get into a 403 state here, which causes logout redirect back to logout. clear the locks before calling unlock
      actions.lock.clear();
      actions.lock.unlockTickets({
        ticketSubsetId: ticketSubset.id,
        ticketGroupId: currentLock.id,
      });
    }

    if (packageLock) {
      actions.packageActions.clear();
      // It is possible to get into a 403 state here, which causes logout redirect back to logout. clear the locks before calling unlock
      actions.lock.clearPackageLock();
      _.forEach(packageLock.locks, (lock) => {
        actions.lock.unlockTickets({
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ticketSubsetId: lock.ticketSubset!.id,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ticketGroupId: lock.ticketSubset!.ticketGroupId,
        });
      });
    }

    actions.app.logout();
    actions.toast.showInfo(onLogoutMessage);
    history.push({
      pathname: '/',
    });
    if (appConfig?.business?.id) {
      refreshCalendar(actions, ticketTypeAccessToken);
    }
  };

  return [doLogout];
};
